export const CREATE_MERCHANT = "CREATE_MERCHANT";
export const UPDATE_MERCHANT = "UPDATE_MERCHANT";
export const DELETE_MERCHANT = "DELETE_MERCHANT";
export const SELECT_MERCHANT = "SELECT_MERCHANT";
export const FETCH_MERCHANTS = "FETCH_MERCHANTS";
export const CREATE_OUTLET = "CREATE_OUTLET";
